import { type StorageDriver, localDriver, sessionDriver } from "./driver";

/**
 * A namespaced, JSON-typed store. Keys are prefixed so different apps/features
 * never collide, and values are (de)serialized with type safety.
 *
 *   const cart = createStore<Cart>("shop:cart", { area: "local" });
 *   cart.set(myCart); const c = cart.get();
 */
export function createStore<T>(
  key: string,
  opts: { area?: "local" | "session"; fallback?: T } = {}
) {
  const driver: StorageDriver = opts.area === "session" ? sessionDriver : localDriver;
  const namespaced = `astro:${key}`;

  return {
    get(): T | undefined {
      const raw = driver.get(namespaced);
      if (raw === null) return opts.fallback;
      try {
        return JSON.parse(raw) as T;
      } catch {
        return opts.fallback;
      }
    },
    set(value: T): void {
      driver.set(namespaced, JSON.stringify(value));
    },
    remove(): void {
      driver.remove(namespaced);
    },
  };
}
